export default {
    driverStatusLogDelete_title: "Delete time cards",
    driverStatusLogDelete_success: "Success",
    driverStatusLogDelete_successMessage: "Time card deleted",
    driverStatusLogDelete_deleteWarning: "Are you sure you want delete the following driver time cards? This action can't be undone"
};